import { TicketDTO, WhenAskForTableCompanions } from 'core/api';
import getTableCompanions from '../ticket/getTableCompanions';
import { CustomError, Result } from 'core/infrastructure';
import { Message } from 'core/ui-next/modal';

type Params = {
	when: WhenAskForTableCompanions,
	ticket: TicketDTO,
	setTableCompanions: (tableCompanions: Nullable<number>) => Promise<Result<void, CustomError>>
}

export default async function setTableCompanionsIfNeeded(params: Params): Promise<Result> {

	const ticket = params.ticket;

	if (ticket.Location.AskForTableCompanions !== params.when)
		return Result.ok();

	if (ticket.TableCompanions)
		return Result.ok();

	const result = await getTableCompanions(ticket, 99);
	if (!result.ok)
		return Result.error();

	const setResult = await params.setTableCompanions(result.value);
	if (!setResult.ok) {
		await Message.show(setResult.error.message);
	}
	return setResult;
}